import PropTypes from "prop-types"
import { usePageAssets } from "hooks/usePageAssets"
import Heading from "components/ui/Heading"
import DecoratedSection from "components/ui/Layout/DecoratedSection"
import SplitContainer from "components/ui/Layout/SplitContainer"

function ModernBISection({ className }) {
  const { getAsset } = usePageAssets()
  const illustration = getAsset("internal-bi-modern-bi-svg")
  return (
    <DecoratedSection className={className}>
      <SplitContainer
        className="py-10 lg:py-20 xl:py-32 2xl:py-40"
        image={illustration}
        imageClassName="mt-10 lg:mt-0 max-w-2xl mx-auto"
      >
        <Heading
          label="Beyond Legacy BI"
          title="Visualizations for the modern data stack"
          subtitle={
            <>
              Unlike traditional BI tools, Preset connects natively to popular
              cloud data warehouses and leading data engines. With built-in dbt
              integration and version control, your dashboards evolve with your
              data stack—not against it.
            </>
          }
          narrow
        />
      </SplitContainer>
    </DecoratedSection>
  )
}

ModernBISection.propTypes = {
  /** Additional className(s) */
  className: PropTypes.string,
}

export default ModernBISection
